import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = ({ customBreadcrumbs = null }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const routeLabels = {
    '/app-dashboard': 'Dashboard',
    '/best-practice-picker': 'Best Practice Picker',
    '/questionnaire-runner': 'Questionnaire Runner',
    '/fit-gap-board': 'Fit/Gap Analysis',
    '/document-generator': 'Document Generator',
    '/digital-signoffs': 'Digital Signoffs'
  };

  const generateBreadcrumbs = () => {
    if (customBreadcrumbs) {
      return customBreadcrumbs;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [];

    // Always start with Dashboard for authenticated routes
    if (location?.pathname !== '/app-dashboard' && pathSegments?.[0] !== 'marketing-home') {
      breadcrumbs?.push({
        label: 'Dashboard',
        path: '/app-dashboard',
        isActive: false
      });
    }

    // Add current page
    const currentLabel = routeLabels?.[location?.pathname];
    if (currentLabel) {
      breadcrumbs?.push({
        label: currentLabel,
        path: location?.pathname,
        isActive: true
      });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Don't render breadcrumbs for marketing pages or if no breadcrumbs
  if (breadcrumbs?.length === 0 || location?.pathname?.includes('marketing-home') || 
      location?.pathname?.includes('pricing-plans') || location?.pathname?.includes('user-login') || 
      location?.pathname?.includes('user-registration')) {
    return null;
  }

  const handleNavigation = (path) => {
    if (path !== location?.pathname) {
      navigate(path);
    }
  };

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {breadcrumbs?.map((breadcrumb, index) => (
          <li key={breadcrumb?.path} className="flex items-center space-x-2">
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-muted-foreground/60"
              />
            )}
            {breadcrumb?.isActive ? (
              <span className="text-foreground font-medium">
                {breadcrumb?.label}
              </span>
            ) : (
              <button
                onClick={() => handleNavigation(breadcrumb?.path)}
                className="hover:text-foreground nav-transition focus:outline-none focus:underline"
              >
                {breadcrumb?.label}
              </button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadcrumbNavigation;